import TimelineLite from 'gsap/TimelineLite';
import BaseComponent from '../../../general/js/base-component';
import stylesFinally from '../../../general/js/style-observer';

export default class HeroColumnComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.init();
    }

    init() {
        stylesFinally(() => {
            this.animate();
        });
    }

    animate() {
        (new TimelineLite()).staggerFrom(this.element.children, 1, {y: '50px', ease: Power4.easeOut}, 0.1);
        this.element.classList.add('is-visible');
    }
}



// WEBPACK FOOTER //
// ./app/components/hero-column/js/hero-column.component.js